import React, { useState, useEffect, useCallback } from 'react';

import './MainNavigation.scss';
import MainHeader from '../MainHeader/MainHeader';
import MainFooter from '../MainFooter/MainFooter';
import NavLinks from '../NavLinks/NavLinks';
import Logo from '../Logo/Logo';
import SideDrawer from '../SideDrawer/SideDrawer';
import Backdrop from '../../UIElements/Backdrop/Backdrop';
import OnlineStoreLink from '../OnlineStoreLink/OnlineStoreLink';
import SNS from '../SNS/SNS';
import Language from '../Language/Language';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
// import FilterBar from '../FilterBar/FilterBar';
import FooterAbout from '../FooterAbout/FooterAbout';
import Newsletter from '../Newsletter/Newsletter';
import SupportLinks from '../SupportLinks/SupportLinks';
import StoresInformation from '../StoresInformation/StoresInformation';
import Copyright from '../Copyright/Copyright';

const MainNavigation = (props) => {
  const { location } = props;

  // Local state
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState('transparent');
  const [isSubHeader, setIsSubHeader] = useState(false);

  // bg: transparent > scroll down > bg: slightly opaque white
  const scrollEventHandler = useCallback(
    (e) => {
      if (location.pathname === '/') {
        window.scrollY < 1
          ? setBackgroundColor('transparent')
          : setBackgroundColor('rgb(255, 255, 255, .95)');
      }
    },
    [location]
  );

  // Lifecycle
  useEffect(() => {
    if (location.pathname === '/') {
      setBackgroundColor('transparent');
      window.addEventListener('scroll', scrollEventHandler);
    } else {
      setBackgroundColor('rgb(255, 255, 255, .95)');
    }
    return () => window.removeEventListener('scroll', scrollEventHandler);
  }, [location, scrollEventHandler]);

  // Side drawer handler (open & close)
  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };
  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  // Conditionally render Sub Header
  // Only NOT render on Home page
  useEffect(() => {
    if (location.pathname === '/') {
      setIsSubHeader(false);
    } else {
      setIsSubHeader(true);
    }
  }, [location]);

  return (
    <React.Fragment>
      {/* side-drawer & backdrop */}
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <nav className="side-drawer__nav">
          <Logo width="80px" height="80px" className="logo--side-drawer" />
          <NavLinks className="nav-links--side-drawer" />
          <div className="side-drawer__online-store-box">
            <OnlineStoreLink className="online-store-link--side-drawer" />
          </div>
          <SNS className="sns--side-drawer" width="15" height="15" />
          <Language className="language--side-drawer" />
        </nav>
      </SideDrawer>
      {/* side-drawer & backdrop */}

      {/* main-header */}
      <MainHeader
        className="main-header"
        // style={!mq.matches ? backgroundColor : 'transparent'}
        style={backgroundColor}
      >
        {/* &__menu-btn */}
        <button className="main-header__menu-btn" onClick={openDrawerHandler}>
          <span />
          <span />
          <span />
        </button>
        {/* &__menu-btn */}
        {/* &__nav */}
        <nav className="main-header__nav">
          <NavLinks className="nav-links--main-header" />
          <Logo width="70px" height="70px" className="logo--main-header" />
          <div className="main-header__nav--right-box">
            <OnlineStoreLink className="online-store-link--main-header" />
            <SNS className="sns--main-header" width="15" height="15" />
            <Language className="language--main-header" />
          </div>
        </nav>
        {/* &__nav */}
        {/* &__sub-header */}
        {isSubHeader && (
          <div className="main-header__sub-header">
            <Breadcrumbs route={location.pathname} />
          </div>
        )}
        {/* &__sub-header */}
      </MainHeader>
      {/* main-header */}

      {/* main */}
      <main
        className={location.pathname !== '/' ? 'main-navigation__main' : null}
      >
        {props.children}
      </main>
      {/* main */}

      {/* main-footer */}
      <MainFooter className="main-footer">
        {/* left */}
        <div className="main-footer__content--left">
          <FooterAbout className="footer-about--main-footer" />
          <Newsletter className="newsletter--main-footer" />
        </div>
        {/* left */}
        {/* right */}
        <div className="main-footer__content--right">
          <nav className="main-footer__nav">
            <NavLinks className="nav-links--main-footer" />
            <SupportLinks />
          </nav>
          <StoresInformation className="stores-information--main-footer" />
        </div>
        {/* right */}
        {/* bottom */}
        <div className="main-footer__content--bottom">
          <Copyright className="copyright--main-footer" />
        </div>
        {/* bottom */}
      </MainFooter>
      {/* main-footer */}
    </React.Fragment>
  );
};

export default MainNavigation;
